import axios from "axios"

const url = 'linkdrive/plataforma/acesso-privado/perfil'

const state = {
  user: null
}

const getters = {
  user: state => state.user
}

const mutations = {
  setUser: (state, payload) => state.user = payload,
}

const actions = {
  async getUsuario({ commit }) {
    const { data: user } = await axios.get(`${url}/meus-dados`)

    commit('setUser', user)
  },
  
  async alterarCadastro(_, params) {
    const { data: resp } = await axios.put(`${url}/meus-dados`, params)

    return resp
  },

  async alterarImagem(_, img) {
    let formData = null
    formData = new FormData()
    formData.append('arquivo', img)
    const { data: resp } = await axios.post(`${url}/imagem-perfil`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    
    return resp
  },

  async alterarSenha(_, params) {
    const { senhaAntual, novaSenha } = params
    const { data: resp } = await axios.put(`${url}/senha?senhaAtual=${senhaAntual}&novaSenha=${novaSenha}`)

    return resp
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}